function formatDimensionId(dimension) {
  if (!dimension) return '';
  const raw = String(dimension).startsWith('field.')
    ? String(dimension).slice(6)
    : String(dimension);
  if (raw === 'response_agent_username' || raw === 'agent_username') {
    return 'Agent Name';
  }
  return raw
    .split(/[._-]/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

import { buildYAxisMeasureLabel } from './measureFieldUtils';
import { isDurationMetricId } from './interveneFilters';

/**
 * Resolve human-readable axis labels for chart rendering.
 */
export function resolveChartAxisLabels({
  chartType,
  dimension,
  metric,
  aggregation = 'count',
  measureField,
  groupByOptions = [],
  measureFieldOptions = [],
  metrics = [],
  timeFieldOptions = [],
  columns = [],
}) {
  const categoryLabel = groupByOptions.find((o) => o.id === dimension)?.label
    || formatDimensionId(dimension);
  const measureFieldLabel = measureFieldOptions.find((o) => o.id === measureField)?.label
    || formatDimensionId(measureField);
  const catalogMetric = metrics.find((item) => item.id === metric);
  const metricLabel = catalogMetric && metric !== 'count'
    ? catalogMetric.label
    : (metric === 'agent_response_time'
      ? 'Agent response time'
      : (buildYAxisMeasureLabel(aggregation, measureFieldLabel) || 'Record count'));
  const timeLabel = timeFieldOptions[0]?.label || 'Created date';
  const valueFormat = isDurationMetricId(metric) ? 'duration' : 'number';
  const columnLabels = Object.fromEntries(
    (columns.length ? columns : (dimension ? [dimension] : [])).map((id) => [
      String(id).replace(/\./g, '__'),
      groupByOptions.find((item) => item.id === id)?.label || formatDimensionId(id),
    ])
  );

  if (chartType === 'line') {
    return {
      xAxisLabel: timeLabel,
      yAxisLabel: metricLabel,
      seriesLabel: metricLabel,
      chartSubtitle: `${metricLabel} by ${timeLabel}`,
      valueFormat,
      columnLabels,
    };
  }

  if (chartType === 'bar') {
    return {
      xAxisLabel: categoryLabel,
      yAxisLabel: metricLabel,
      seriesLabel: metricLabel,
      chartSubtitle: categoryLabel ? `${metricLabel} by ${categoryLabel}` : metricLabel,
      valueFormat,
      columnLabels,
    };
  }

  if (chartType === 'table' || chartType === 'pie') {
    return {
      xAxisLabel: categoryLabel,
      yAxisLabel: metricLabel,
      seriesLabel: categoryLabel,
      chartSubtitle: chartType === 'table' && columns.length
        ? columns.map((id) => columnLabels[String(id).replace(/\./g, '__')]).filter(Boolean).join(', ')
        : (categoryLabel ? `${metricLabel} by ${categoryLabel}` : metricLabel),
      valueFormat,
      columnLabels,
    };
  }

  return {
    xAxisLabel: '',
    yAxisLabel: metricLabel,
    seriesLabel: metricLabel,
    chartSubtitle: metricLabel,
    valueFormat,
    columnLabels,
  };
}

export default resolveChartAxisLabels;
